import { motion } from "framer-motion";
import { Zap, GitBranch, Timer, TrendingUp } from "lucide-react";

const points = [
  {
    icon: Zap,
    title: "Terminals are becoming agent runtimes",
    description: "Coding sessions used to be manual input tools. Now they run semi-autonomous AI workflows that take 10, 30, even 60 minutes.",
  },
  {
    icon: GitBranch,
    title: "Developers need supervision, not babysitting",
    description: "The job is shifting from 'type commands' to 'monitor and direct agents.' That requires a different interface.",
  },
  {
    icon: Timer,
    title: "Old tools are workarounds",
    description: "SSH from your phone, remote desktop on a 6-inch screen, keeping your laptop open at lunch. These aren't solutions. They're cope.",
  },
  {
    icon: TrendingUp,
    title: "The shift is accelerating",
    description: "Claude Code, Codex CLI, Aider, Cursor Agent — every major tool is building toward long-running agent workflows.",
  },
];

export default function WhyNowSection() {
  return (
    <section
      data-testid="why-now-section"
      className="py-24 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-16"
        >
          <span
            className="text-xs uppercase tracking-wider mb-4 block"
            style={{
              color: "#A1A1AA",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
            }}
          >
            Why now
          </span>
          <h2
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-white leading-tight"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Built for the shift from manual terminals{" "}
            <span style={{ color: "#71717A" }}>
              to agent runtime environments.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {points.map((point, i) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="flex gap-4"
            >
              <div
                className="w-10 h-10 rounded-lg flex-shrink-0 flex items-center justify-center"
                style={{
                  background: "rgba(255,255,255,0.04)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <point.icon className="w-4 h-4 text-white" strokeWidth={1.5} />
              </div>
              <div>
                <h3
                  className="text-base font-medium text-white mb-2"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {point.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: "#71717A" }}>
                  {point.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
